const dateFormat = new Intl.DateTimeFormat('en', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
});

window.okeReviewsWidgetOnInit = function () {
    const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMain) {
        const observer = new MutationObserver(formatDateForElement);
        observer.observe(reviewMain, { childList: true });
        formatDateForElement();
    }

    const aggregateSummary = document.querySelector(".okeReviews-reviewsAggregate-summary-total");
    if (aggregateSummary && reviewMain) {
        reviewMain.insertAdjacentElement("beforebegin", aggregateSummary);
    }

    // Remove 'Based on' text on Aggregate Summary Total
    const str = document.querySelector(".okeReviews-reviewsAggregate-summary-total")
    if (str) {
        str.innerHTML = str.innerHTML.replace(/Based on/g, "");;
    }

    // Move Aggregate Primary on custom header
    const aggregateModItem = document.querySelector(".okeReviews-reviewsAggregate-mod-itm--attRtgAv");
    const topAggRatingContainer = document.querySelector(".okeReviewsAgg-rating");
    if (aggregateModItem && topAggRatingContainer) {
        topAggRatingContainer.insertAdjacentElement("afterbegin", aggregateModItem);
    }
}

window.okeReviewsQandaOnInit = function () {
    const questionMain = document.querySelector('.js-okeReviews-questions-main');
    if (questionMain) {
        const observer = new MutationObserver(formatDateForElement);
        observer.observe(questionMain, { childList: true });
        formatDateForElement();
    }
}

window.addEventListener("DOMContentLoaded", (event) => {
    const navbar = document.querySelector("[data-oke-reviews-nav-bar]");
    if (navbar) {
        const callback = function () {
            const reviewCount = document.querySelector(".okeReviews-widgetNavBar-item:first-child .okeReviews-widgetNavBar-count");
            const qandaCount = document.querySelector(".okeReviews-widgetNavBar-item:nth-child(2) .okeReviews-widgetNavBar-count");
            const reviewContainer = document.querySelector(".okeReviews-total-reviewCount");
            const qandaContainer = document.querySelector(".okeReviews-total-questionsCount");

            if (reviewCount) {
                reviewContainer.innerText = `${reviewCount.innerText} Review${reviewCount.innerText > 1 ? 's' : ''}, `;
            } else {
                reviewContainer.innerText = `0 Reviews, `;
            }

            if (qandaCount) {
                qandaContainer.innerText = `${qandaCount.innerText} Q&A${qandaCount.innerText > 1 ? 's' : ''}`;
            } else {
                qandaContainer.innerText = `0 Q&As`;
            }

        };
        const observer = new MutationObserver(callback);
        observer.observe(navbar, { childList: true });
    }
});

function formatDateForElement() {
    const reviewDates = document.querySelectorAll('[data-oke-reviews-date]');
    for (const reviewDate of reviewDates) {
        const dateIsoString = reviewDate.getAttribute('data-oke-reviews-date');
        const date = new Date(dateIsoString);
        const localeDate = `${dateFormat.format(date)}`;
        reviewDate.innerText = localeDate;
    }
}